// extracted by mini-css-extract-plugin
export default {"list":"UploadTeamForm_list__Q7FwU"};